import { render, staticRenderFns } from "./adminView.pug?vue&type=template&id=77ae1a89&lang=pug&"
import script from "./adminView.js?vue&type=script&lang=js&"
export * from "./adminView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ae1a89')) {
      api.createRecord('77ae1a89', component.options)
    } else {
      api.reload('77ae1a89', component.options)
    }
    module.hot.accept("./adminView.pug?vue&type=template&id=77ae1a89&lang=pug&", function () {
      api.rerender('77ae1a89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/views/adminView/index.vue"
export default component.exports